import { render, staticRenderFns } from "./CheckboxModal.vue?vue&type=template&id=10bf320a&scoped=true"
import script from "./CheckboxModal.vue?vue&type=script&lang=js"
export * from "./CheckboxModal.vue?vue&type=script&lang=js"
import style0 from "./CheckboxModal.vue?vue&type=style&index=0&id=10bf320a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bf320a",
  null
  
)

export default component.exports